import { reactive } from "vue";

interface PaginationOptions {
  pageNum?: number;
  pageSize?: number;
  totalPage?: number;
  totalCount?: number;
}

export default function Pagination (pageInfo: PaginationOptions = { pageNum: 1, pageSize: 10, totalPage: 1, totalCount: 0 }) {
  const { pageNum = 1, pageSize = 50, totalPage = 1, totalCount = 0 } = pageInfo;
  return reactive({
    pageNum,
    pageSize,
    totalPage,
    totalCount
  });
}